import React from "react";
import ReactDOM from "react-dom";

import Button from "../../Button/Button";
import "./MessageModal.css";

const MessageModal = (props) =>
  ReactDOM.createPortal(
    <div className="messageModal">
      <div className="messageModal__content">{props.children}</div>
      <div className="messageModal__actions">
        <Button
          design="greenish"
          mode={""}
          wide={""}
          type="submit"
          onClick={props.onAcceptModal}
          disabled={!props.acceptEnabled}
          loading={props.isLoading}
        >
          {props.acceptMessage}
        </Button>

        <Button
          design="footer"
          mode={""}
          wide={"wide"}
          onClick={props.onCancelModal}
          disabled={!props.acceptEnabled}
          loading={props.isLoading}
        >
          {props.cancelMessage}
        </Button>
      </div>
    </div>,
    document.getElementById("modal-root")
  );

export default MessageModal;
